import CSQCAxios from '@/outils/CSQCAxios';

const CONTROLLER_NAME = 'EleveInscription';
export default {
  clearCache: false,
  obtenirListeCssMinimise() {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/ListeCssMinimise`);
  },
  obtenirListeCoursLigne(cssId, organisme, scolariseMaison, estBoutique = false) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/ListeCoursLigne/Organisme/${organisme}/CSS/${cssId}?estBoutique=${estBoutique}&scolariseMaison=${scolariseMaison}`);
  },
  validerEleve(courriel, dateNaissance, cssId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/ValiderEmailEleve?courriel=${courriel}&dateNaissance=${dateNaissance}&cssId=${cssId}`);
  },
  acheterPanier(identificationEleve) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/AcheterPanier`, identificationEleve);
  },
  coursDejaAchete(identificationEleve) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/CoursDejaAchete`, identificationEleve);
  },
  coursNonEligible(identificationEleve) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/CoursNonEligible`, identificationEleve);
  },
  retirerCoursBlocInactif(cours) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/RetirerCoursBlocInactif`, cours);
  },
  obtenirMesuresAides(cssId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/CSS/${cssId}/MesuresAides`);
  },
  verifierSiGratuit(informationPanierVM) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/VerifierSiGratuit`, informationPanierVM);
  },
  verifierSiDejaPaye(informationPanierVM) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/VerifierSiDejaPaye`, informationPanierVM);
  },
  rafraichirPanier(coursPanier) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/RafraichirPanier`, coursPanier);
  },
  envoyerFichier(idEleveEcole, typeDocument, fichier, typeDocumentEnum) {
    const fichiers = new FormData();
    fichiers.append('fichiers', fichier, fichier.name);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    const axios = CSQCAxios.getAxios();
    axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';
    return axios.post(`${CONTROLLER_NAME}/EnvoyerFichier/${idEleveEcole}/TypeDocument/${typeDocument}?typeDocumentEnum=${typeDocumentEnum}`, fichiers, config);
  },

  obtenirBlocOrganisme(anneeScolaire) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/BlocsOrganisme?anneeScolaire=${anneeScolaire}`);
  },
  obtenirOptionsCSS() {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/OptionsCSS`);
  },
  validerInscriptionExamen(informationPanierVM) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/ValiderInscriptionExamen`, informationPanierVM);
  },
  validerInscriptionCoursGratuit(informationPanierVM) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/ValiderInscriptionCoursGratuit`, informationPanierVM);
  },
  demandeFileAttente(infosCourriel, informationPanierVM) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/DemandeFileAttente`, { infosCourriel, informationPanierVM });
  },
  obtenirDocumentsPanier(coursPanier) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}/Cours/Documents`, coursPanier);
  },
  obteniOrganismeGratuit(cssId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/Organisme/Gratuit/CSS/${cssId}`);
  },
};
